module.exports = __webpack_public_path__ + "img/screen_5_example.047b7440.png";